<!--
 * @Description: 
 * @Author: Roger Wei
 * @Date: 2022-04-24 10:29:33
 * @LastEditTime: 2022-04-24 15:35:50
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
-->
<!--
 * @Description: 车辆转派审批
 * @Author: wangwangwang
 * @Date: 2020-12-02 15:14:12
 * @LastEditors: Roger Wei
 * @LastEditTime: 2022-04-24 09:45:44
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-form :inline="true" :model="formData" label-width="110px" style="display: flex;flex-direction: row;justify-content: center;">
                <el-form-item>
                  <span v-if="SCMUser.length>0?SCMUser[0].hideType!=2:true" slot="label">SCM角色</span>
                  <el-input v-if="SCMUser.length>0?SCMUser[0].hideType==1:true" v-model="formData.SCM_ROLE" :disabled="SCMUser.length>0?!SCMUser[0].readonly:false"></el-input>
                </el-form-item>
                <el-form-item>
                  <span v-if="SCMUser.length>0?SCMUser[1].hideType!=2:true" slot="label">SCM人事字段</span>
                  <el-input v-if="SCMUser.length>0?SCMUser[1].hideType==1:true" v-model="formData.SCM_RCZD" :disabled="SCMUser.length>0?!SCMUser[1].readonly:false"></el-input>
                </el-form-item>
                <el-form-item>
                  <span v-if="SCMUser.length>0?SCMUser[2].hideType!=2:true" slot="label">CRM组织</span>
                  <el-input v-if="SCMUser.length>0?SCMUser[2].hideType==1:true" v-model="formData.SCM_ORG" :disabled="SCMUser.length>0?!SCMUser[2].readonly:false"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @getSCMUser="getSCMUser" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness"/>
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '流程测试1',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {
        SCM_ROLE: '',
        SCM_RCZD: '',
        SCM_ORG: '',
      },
      SCMUser: [],
    }
  },
  created() {
    this.getSCMUser();
  },
  methods: {
    handleBusiness () {
      const params = {
        process_success: {
          url: '/icps/system/sign/dataCollection/supplierPlanDetail/carRedeploy',
          data: {
            ...this.formData,
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish() {
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType*1 !== 2) { // 发起流程
        // this.showSendVisible = true;
        this.$refs.flowcontent.processBefore(this.formData);
        return
      }

      console.log(type, 442323)

      const data = {
        dataSource: 'QIUBO_SCM_TEST',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData() {
      // this.formData = defaultData;
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
    getSCMUser(val) {
      this.SCMUser = val?JSON.parse(val):[];
    }
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData('QIUBO_SCM_TEST');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData2();
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
</style>
